import styled from "styled-components";

const ProgressBar = styled.div`
  width: 328px;
  height: 8px;
  background-color: rgba(147, 112, 219, 0.3);
  border-radius: 24px;
  margin-top: 30px;

  & > .inner{
    width: ${props => props.iw}%;
    height: 100%;
    background-color: purple;
    border-radius: 24px;
  }
`;

export const Progress = ({ page }) => {
  let iw = page === "checkList" ? 90 : 82/328 * 100 * page;

  return(
    <ProgressBar className="App-progress" iw={iw}>
      <div className="inner"></div>
    </ProgressBar>
  );
}